// fast and easy helper
const isMobile = ( breakpoint = 556 ) =>
  window.innerWidth < breakpoint;

/**
 *
 * @param queryParam
 * @param pageIndex
 * @returns {Promise<any>}
 */
export default function getPopularPosts( queryParam = '', pageIndex = 1 ) {
  const query = queryParam ? `&q=${queryParam}` : '';
  const requestURL = `https://api.parsely.com/v2/search?apikey=adweek.com&endpoint=/search${query}&sort=views&boost=views&limit=10&page=${pageIndex}`;

  return fetch(requestURL)
    .then( response => response.json() )
	  .catch( err => {
	    console.error( 'Developer message: Error in fetching parsley popular posts data: ' + err );
  } );
}


/** Async helper for getting posts from Parsely from the WP server. */
export function fetchPosts( query, callback ) {
  return new Promise( ( resolve, reject ) => {
    const options = {
      data: {
        action: 'parsely_get_posts',
        ...query
      }
    }

    /** Makes controlled Ajax request with hooks to set request status. */
    const ajax = ( options ) => {
      let settings = Object.assign( {
        url: adw.ajaxurl,
        beforeSend: _ => console.log('FINDERR'.repeat(10)),
        success: ( response ) => {
          const { message, data, error } = response.data;

          if ( error ) {
            console.warn( message );
            throw error;
          }

          if ( typeof callback == 'function' )
            callback( data );

          resolve( data );
        },
        error: err => {
          console.warn( "In AJAX request for parsely");
          console.warn( err );
          if ( typeof callback == 'function' )
            callback( err );

          reject( err );
        }
      } , options );


      jQuery.post( settings );
    }

    return ajax( options );
  } );

}


/**
 * Generic getter for fetching posts via Parsely
 *
 * @param Object query API Settings applied to Parsely
 * @return Promise Promise resolving to the queried values or a rejection on error.
 */
function _deprecated_getPosts( query = {} ) {

  // Allow common names for `q` parameter
  const q = query.s || query.search || query.keyword || query.query || '';
  const baseURL = 'https://api.parsely.com/v2/search?apikey=adweek.com';
  const params = Object.assign( {
    endpoint: 'search',
    q: '',
    boost: isMobile() ? 'mobile_views' : 'views',
    sort: 'score',
    tag: '',
    author: '',
    page: 1,
    limit: 10,
    // pub_date_start: '',  requires special date format
    // pub_date_end: ''  requires special date format
  }, query, {q} );

  if ( params.boost.length > 0 && params.sort !== 'score' ) {
    // This option is only valid when `sort=score`
    delete params.boost;
  }

  const requestURL = Object.entries( params ).reduce( addParam, baseURL );
  return fetch( requestURL )
    .then( response => response.json() )
    .catch( err => {
      console.error( 'Developer message: Error in fetching parsley popular posts data: ' + err );
  } );
}


/** Reducer for adding query parameters or skip if not defined */
function addParam( queryString, [key, value] ) {
  if ( !value ) {
    return queryString;
  }

  const v = typeof value == 'string'
    ? value
    : typeof value.toString == 'function'
      ? value.toString()
      : JSON.stringify( value )


  return `${queryString}&${key}=${ v }`;
}
